// extracted by mini-css-extract-plugin
module.exports = {"button":"G_cr","button__primary":"G_cs","button__red":"G_ct","button__secondary":"G_cv","button__secondary__white":"G_cw","button__tertiary":"G_cx"};